//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { AbstractCategoryModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({
   types: [AbstractCategoryModel],
})
@Component({
    selector: 'category-presenter',
    template: '<category-item [id]="data().id" [category]="data()" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryPresenterComponent {
    public data: WritableSignal<AbstractCategoryModel> = signal<AbstractCategoryModel>(null);

}